module.exports = __webpack_public_path__ + "img/product_3.b41209d.webp";